export default {
  path: "/prospect",
  component: () =>
    import(/* webpackChunkName: "prospect" */ "@/views/prospect/index.vue"),
};
